import register       from '../../register.js';
import $              from 'jquery';
import FormSequence   from '../classes/form-sequence';
import extend         from '../util/extend';
import utm            from '../util/utm';

import wait_list_contact from '../steps/wait-list-contact/step';
import success           from '../steps/wait-list-success/step';
import error             from '../steps/error/step';
import footerTemplate    from '../templates/components/footer.hbs';

export default register( 'wait_list', () => {

  const sequence = new FormSequence({
    $el: $('.signup-container'),
    first: 'contact',
    configs: {
      contact: {
        step: wait_list_contact,
        title: 'My Address',
        next: null,
        footer: footerTemplate({ pii_waitlist: true })
      },
      error: {
        step: error,
        next: null
      },
      success: {
        step: success,
        title: 'Confirmed',
        next: null
      }
    },
    submit() {
      const url = '/waitlist';
      const successStep = 'success';

      const state = extend( {}, this.store.getState() );

      let data = {
        street_number: state.address.street_number,
        street: state.address.street,
        neighborhood: state.address.neighborhood,
        borough: state.address.borough,
        city: state.address.city,
        state: state.address.state,
        country: state.address.country,
        postal_code: state.address.postal_code,
        first_name: state.first_name,
        last_name: state.last_name,
        email: state.email,
        phone: state.phone,
        apt: state.address.apt,
        lat: state.address.lat,
        lng: state.address.lng,
        place_id: state.address._id,
        sms_consent: Boolean( state.sms_consent ),
        hdyhau: state.hdyhau || null,
        flow: 'waitlist'
      };

      data = extend( data, utm() );

      const btn = this.$el.find( this.submitSelector );

      btn.addClass('loading');

      try {
        data = JSON.stringify( data );
      } catch ( e ) {
        console.log( e );
      }

      $.ajax({
        method: 'POST',
        url,
        contentType: 'application/json',
        data,
        success: user => {
          sequence.onSuccess( successStep );

          if ( window.acumen ) {
            window.acumen.identify({
              email: user.email,
              place_id: user.place_id
            });
          }
        },
        complete: () => {
          btn.removeClass('loading');
        },
        error: () => {

          sequence.showStep('error');

          const $submit = sequence.$el.find('.sequence-submit');
          $submit.addClass('hidden');
        }
      });
    },

    // this is gross, but honestly, it seemed wrong to try to bake this in
    // to FormSequence generically, because I don't think it's likely that
    // success pages will always behave this way
    onSuccess( successStep ) {
      sequence.showStep( successStep );
      sequence.$el.find('.sequence-prev, sequence-submit').hide();

      const $submit = sequence.$el.find('.sequence-submit');

      $submit.off();
      $submit.text('Done');

      $submit.on( 'click', ( ev ) => {
        ev.stopPropagation();
        window.location = 'https://starry.com/internet';
      });
    }
  });

  window.sequence = sequence;

});
